/* ABC: просмотр фотографии товара.
   Владелец просил: крестик не круглый, открытие без «уезжающего» зума,
   листание стрелками на клавиатуре и увеличение по клику, чтобы
   разглядывать детали.

   Просмотрщик темы — вертикальный список кадров (.dialog-zoomed-gallery > li,
   каждый высотой в экран), поэтому листание = прокрутка к соседнему кадру. */
(function () {
  var ZOOM = 2.2;

  /* ── плавное закрытие просмотра ──────────────────────────────────────
     dialog.close() гасит окно мгновенно. Патчим сам метод: сначала
     проигрываем затухание, потом зовём нативный close.
     ВАЖНО: анимация только по opacity. Любой transform на диалоге делает
     его точкой отсчёта для position:fixed, и крестик закрытия уезжает
     вместе с прокруткой — этим я уже обжёгся. */
  var nativeClose = HTMLDialogElement.prototype.close;

  function patchClose(d) {
    if (!d || d.dataset.abcClosePatched) return;
    d.dataset.abcClosePatched = '1';
    d.close = function () {
      if (!this.open || this.dataset.abcClosing) return;
      var el = this;
      el.dataset.abcClosing = '1';
      el.classList.add('abc-zoom-closing');
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        el.classList.remove('abc-zoom-closing');
        delete el.dataset.abcClosing;
        nativeClose.call(el);
      }
      el.addEventListener('animationend', finish, { once: true });
      setTimeout(finish, 300);
    };
  }

  /* У кадра просмотра тема вешает on:click="/close" — клик по ЛЮБОМУ месту
     фотографии закрывал просмотр, поэтому увеличение по клику не включалось
     вовсе. Снимаем атрибут: закрытие оставляем на крестик, Escape и клик
     по полям мимо фото, а клик по самой фотографии увеличивает. */
  function disarmSlideClose() {
    document.querySelectorAll(':is(zoom-dialog,abc-zoom) .dialog-zoomed-gallery > li[on\\:click]')
      .forEach(function (li) { li.removeAttribute('on:click'); });
  }

  /* Крестик просмотра владелец просит ставить ровно на место корзины —
     и на телефоне, и на ПК. Позиция значка зависит от ширины экрана,
     поэтому снимаем её вживую при каждом открытии, а не хардкодим. */
  function placeClose(d) {
    var btn = d.querySelector('.close-button');
    if (!btn) return;
    var icon = document.querySelector('cart-icon') ||
               document.querySelector('.header-actions__cart-icon');
    if (!icon) return;
    var r = icon.getBoundingClientRect();
    if (!r.width || !r.height) return;
    btn.style.setProperty('top', Math.round(r.top) + 'px', 'important');
    btn.style.setProperty('right', Math.round(window.innerWidth - r.right) + 'px', 'important');
    btn.style.setProperty('width', Math.round(r.width) + 'px', 'important');
    btn.style.setProperty('height', Math.round(r.height) + 'px', 'important');
  }

  function watchOpen(d) {
    if (d.dataset.abcClosePlaced) return;
    d.dataset.abcClosePlaced = '1';
    if (d.hasAttribute('open')) placeClose(d);
    new MutationObserver(function () {
      if (d.hasAttribute('open')) placeClose(d);
    }).observe(d, { attributes: true, attributeFilter: ['open'] });
  }

  function patchAll() {
    document.querySelectorAll(':is(zoom-dialog,abc-zoom) dialog').forEach(function (d) {
      patchClose(d);
      watchOpen(d);
    });
    disarmSlideClose();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', patchAll);
  else patchAll();
  new MutationObserver(patchAll).observe(document.documentElement, { childList: true, subtree: true });


  function viewer() {
    var d = document.querySelector(':is(zoom-dialog,abc-zoom) dialog[open]');
    return d || null;
  }
  function slides(d) {
    return Array.from(d.querySelectorAll('.dialog-zoomed-gallery > li'));
  }
  /* Текущий кадр — тот, чей центр ближе всего к центру экрана.
     Раньше считали по offsetTop от прокрутки dialog, а прокручивается
     не всегда он — стрелки доходили только до 2-го кадра. */
  function currentIndex(d) {
    var list = slides(d);
    var cy = window.innerHeight / 2, cx = window.innerWidth / 2;
    var best = 0, bestDist = Infinity;
    for (var i = 0; i < list.length; i++) {
      var r = list[i].getBoundingClientRect();
      var dist = Math.abs(r.top + r.height / 2 - cy) + Math.abs(r.left + r.width / 2 - cx);
      if (dist < bestDist) { bestDist = dist; best = i; }
    }
    return best;
  }
  function go(d, delta) {
    var list = slides(d);
    if (!list.length) return;
    var i = Math.min(list.length - 1, Math.max(0, currentIndex(d) + delta));
    /* 25.09: увеличение НЕ сбрасываем здесь — фото резко «схлопывалось» и только
       потом ехало. Кадр уезжает как есть (обрезан своим li), а сбрасывается,
       когда полностью ушёл с экрана (обработчик scroll ниже) */
    list[i].scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
  }

  /* ушли на другой кадр любым способом (колесо, свайп, стрелки) —
     увеличение у всех кадров сбрасываем: возвращаясь, человек видит фото
     целиком, а не то место, где приближал */
  document.addEventListener('scroll', function (e) {
    var d = viewer();
    if (!d || !e.target || !d.contains(e.target) && e.target !== d) return;
    d.querySelectorAll('.dialog-zoomed-gallery img').forEach(function (img) {
      if (img.dataset.abcZoomed !== '1' && !img.style.transform) return;
      var li = img.closest('li');
      var r = (li || img).getBoundingClientRect();
      var gone = r.bottom <= 0 || r.top >= window.innerHeight || r.right <= 0 || r.left >= window.innerWidth;
      if (!gone) return;
      img.style.transition = 'none';   /* кадра не видно — сбрасываем незаметно */
      resetZoom(img);
      img.style.transition = 'none';
    });
  }, true);

  /* Где на экране реально нарисовано фото.
     У картинки object-fit:contain и бокс во всю ширину окна, поэтому само
     фото занимает только середину. Если считать точку клика от бокса,
     зум уезжает не туда — отсюда и «ломаная» анимация. Считаем от фото. */
  function painted(img) {
    var r = img.getBoundingClientRect();
    var nw = img.naturalWidth, nh = img.naturalHeight;
    if (!nw || !nh) return r;
    var scale = Math.min(r.width / nw, r.height / nh);
    var w = nw * scale, h = nh * scale;
    return {
      left: r.left + (r.width - w) / 2,
      top: r.top + (r.height - h) / 2,
      width: w,
      height: h
    };
  }

  function resetZoom(img) {
    img.dataset.abcZoomed = '';
    img.style.transition = '';          // вернуть плавность для следующего зума
    img.style.transformOrigin = '50% 50%';
    img.style.transform = '';
    img.style.cursor = 'zoom-in';
  }

  /* увеличение по клику: масштабируем от точки, по которой кликнули,
     чтобы приближалась именно та деталь, на которую смотрит человек */
  function toggleZoom(img, ev) {
    if (img.dataset.abcZoomed === '1') { resetZoom(img); return; }

    var p = painted(img);
    var r = img.getBoundingClientRect();
    /* клик мимо фото (в поля по бокам) — закрываем просмотр.
       Так привычнее и не надо целиться в крестик. */
    if (ev.clientX < p.left || ev.clientX > p.left + p.width ||
        ev.clientY < p.top || ev.clientY > p.top + p.height) {
      var d = viewer();
      if (d) d.close();
      return;
    }

    /* origin задаём в процентах ОТ БОКСА, но точку берём на фото */
    var x = ((ev.clientX - r.left) / r.width) * 100;
    var y = ((ev.clientY - r.top) / r.height) * 100;
    img.dataset.abcZoomed = '1';
    img.style.transition = '';   /* после незаметного сброса стояло 'none' */
    img.style.transformOrigin = x + '% ' + y + '%';
    img.style.transform = 'scale(' + ZOOM + ')';
    img.style.cursor = 'zoom-out';
    startPan(img);
  }

  /* Пока фото увеличено, оно следует за курсором — человек водит мышью
     и разглядывает детали, не перетаскивая картинку. Повторный клик
     возвращает обычный размер. */
  function startPan(img) {
    if (img.dataset.abcPan) return;
    img.dataset.abcPan = '1';
    function onMove(e) {
      if (img.dataset.abcZoomed !== '1') return;
      var p = painted(img);
      var r = img.getBoundingClientRect();
      /* курсор вне кадра — ничего не двигаем */
      if (e.clientX < p.left || e.clientX > p.left + p.width) return;
      if (e.clientY < p.top || e.clientY > p.top + p.height) return;
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      /* без плавности: за курсором надо следовать сразу, иначе «плывёт» */
      img.style.transition = 'none';
      img.style.transformOrigin = x + '% ' + y + '%';
    }
    img.addEventListener('mousemove', onMove);
    img.dataset.abcPanBound = '1';
  }

  /* Кадры в просмотрщике грузятся лениво: при переходе стрелкой следующее
     фото ещё не загружено. Бокс теперь держит размер сам (CSS), но чтобы
     не было пустого кадра — при открытии просмотра грузим все сразу. */
  function eagerLoad(d) {
    d.querySelectorAll('.dialog-zoomed-gallery img').forEach(function (img) {
      img.loading = 'eager';
      if (img.dataset.abcEager) return;
      img.dataset.abcEager = '1';
      if (img.currentSrc || img.src) { var w = new Image(); w.src = img.currentSrc || img.src; }
    });
  }
  new MutationObserver(function () {
    var d = viewer();
    if (d) eagerLoad(d);
  }).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['open'] });

  document.addEventListener('keydown', function (e) {
    var d = viewer();
    if (!d) return;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); go(d, 1); }
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); go(d, -1); }
  });

  document.addEventListener('click', function (e) {
    var d = viewer();
    if (!d) return;
    var img = e.target.closest ? e.target.closest('.dialog-zoomed-gallery img') : null;
    if (!img) return;
    /* на телефоне зум двумя пальцами и двойным тапом — abc-zoom-touch.js;
       одиночный тап ничего не делает, закрытие крестиком */
    if (window.abcZoomIsTouch && window.abcZoomIsTouch()) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    toggleZoom(img, e);
  }, true);

  /* при закрытии сбрасываем увеличение, иначе в следующий раз
     просмотр откроется уже приближённым */
  document.addEventListener('close', function (e) {
    if (!e.target || e.target.tagName !== 'DIALOG') return;
    e.target.querySelectorAll('.dialog-zoomed-gallery img').forEach(function (i) {
      i.dataset.abcZoomed = '';
      i.style.transform = '';
      i.style.transformOrigin = '50% 50%';
    });
  }, true);
})();

